<template>
    <i
        v-if="isImpersonatingUser"
        class="fa-thin fa-user-secret text-white"
        v-tooltip="`You\'re impersonating this user.\nClick to stop impersonating.`"
        @click="stopImpersonating"
    />
    <i
        v-else-if="isImpersonatingTenant && GlobalState.isInstall"
        class="fa-thin fa-life-ring text-white"
        v-tooltip="`MSP Mode\nYou\'re signed into a customer's Zyno Desktop install.`"
    />
    <i
        v-else-if="isImpersonatingTenant"
        class="fa-thin fa-life-ring text-white"
        v-tooltip="`MSP Mode\nYou\'re impersonating a customer tenant.\nClick to stop impersonating.`"
        @click="returnToMspTenant"
    />
</template>

<script lang="ts" setup>
import { GlobalState } from '@/global';
import { withWait } from '@/shared/helpers/request.helpers';
import { Auth } from '@/shared/services/auth.service';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const isImpersonatingUser = computed(() => !!Auth.impersonatorUserId.value);
const isImpersonatingTenant = computed(() => !!Auth.impersonatorTenantId.value);
const router = useRouter();

async function stopImpersonating() {
    withWait('Deimpersonating...', async () => {
        Auth.clearImpersonatedUser();
        await Auth.loadExistingSession();
    });
}

function returnToMspTenant() {
    withWait('Returning to MSP tenant...', async () => {
        Auth.clearImpersonatedTenant();
        await Auth.reloadExistingSessionForTenantSwitch(router);
    });
}
</script>
